import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import HowItWorks from "@/components/landing/HowItWorks";
import Fleet from "@/components/landing/Fleet";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

const LandingPage = () => (
  <div className="min-h-screen bg-white antialiased">
    <Navbar />
    <main>
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <HowItWorks />
      <Fleet />
      <Contact />
    </main>
    <Footer />
  </div>
);

export default LandingPage;
